import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventCategoryState }  from 'Redux/Slices/EventCategory/EventCategorySlice';
import { EventCategory }        from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const updateEventCategoryRequest = (state: Draft<IEventCategoryState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const updateEventCategorySuccess = (state: Draft<IEventCategoryState>, { type, payload }: PayloadAction<{
  eventCategory: EventCategory
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.eventCategory.id;
  state.entries = { ...state.entries, [payload.eventCategory.id]: payload.eventCategory };
};

export const updateEventCategoryFailure = (state: Draft<IEventCategoryState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
